import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Advisory from "./Advisory";
import Login from "./Login";
import AllTableData from "./All-Table-Data";
import Configuration from "./Configuration";
import Locations from "./Locations";
import Fisherman from "./Fisherman";
import ExtensionOfficer from "./ExtensionOfficer";
import AboutUs from "./AboutUs";
import Profile from "./Profile";
import UserManagement from "./UserManagement";
import MessageLogs from "./MessageLogs";
import Threshold from "./Threshold";
import AddNew from "./AddNew";
import AdvisoryManagement from "./AdvisoryManagement";
import AdvisoryManagement1 from "./AdvisoryManagement1";
import Dashboard from "./Dashboard";
import ChatBoatHome from "./ChatBoatHome";
import EditInput from "./EditInput";
import RegularUser from "./RegularUser";
import AdvisoryLocation from "./AdvisoryLocation";
import ChatBox from "./ChatBox";
import RegisteredUsers from "./RegisteredUsers";
import RiskMap from "./RiskMap";
import PhoneSmsLogs from "./PhoneSmsLogs";
import AnalyticsFaoAsis from "./AnalyticsFaoAsis";
// import AdvisoryFlow from "./advisory_recipient_flow";
// import AdvisoryConsole from "./advisory-automation-config";
const ProtectedRoute = ({ children, allowedRoles }) => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
  return allowedRoles.includes(userDetails.role_id) ? children : <Navigate to="/" replace />;
};
function WorldFishRouter() {
  return (
    <Routes>
      <Route path="/" element={<Advisory />} />
      <Route
        path="/threshold"
        element={
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <Threshold />
          </ProtectedRoute>
        }
      />
      <Route
        path="/add-new"
        element={
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <AddNew />
          </ProtectedRoute>
        }
      />
      <Route
        path="/advisory-management1"
        element={
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <AdvisoryManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/advisory-management"
        element={
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <AdvisoryManagement1 />
          </ProtectedRoute>
        }
      />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/allData"
        element={
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <AllTableData />
          </ProtectedRoute>
        }
      />
      <Route
        path="/configuration"
        element={
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <Configuration />
          </ProtectedRoute>
        }
      />
      <Route
        path="/locations"
        element={
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <Locations />
          </ProtectedRoute>
        }
      />
      <Route
        path="/fisherman"
        element={
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <Fisherman />
          </ProtectedRoute>
        }
      />
      <Route
        path="/extension-officer"
        element={
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <ExtensionOfficer />
          </ProtectedRoute>
        }
      />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/home" element={<ChatBoatHome />} />
      <Route path="/edit-input" element={<EditInput />} />
      <Route path="/regular-user" element={<RegularUser />} />
      <Route path="/location" element={<AdvisoryLocation />} />
      <Route path="/chat" element={<ChatBox />} />
      <Route
        path="/user-management"
        element={
          <ProtectedRoute allowedRoles={[1]}>
            <UserManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/registered-users"
        element={
          <ProtectedRoute allowedRoles={[1]}>
            <RegisteredUsers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/message-logs"
        element={
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <MessageLogs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/risk-map"
        element={
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <RiskMap />
          </ProtectedRoute>
        }
      />
      <Route
        path="/phone-number-logs"
        element={
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <PhoneSmsLogs />
          </ProtectedRoute>
        }
      />
      <Route path="/analytics" element={<Navigate to="/analytics/fao-asis" replace />} />
      <Route
        path="/analytics/fao-asis"
        element={
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <AnalyticsFaoAsis />
          </ProtectedRoute>
        }
      />
      {/* temporary design preview routes */}
      {/* <Route path="/design/advisory-flow" element={<AdvisoryFlow />} />
      <Route path="/design/advisory-automation" element={<AdvisoryConsole />} /> */}
    </Routes>
  );
}
export default WorldFishRouter;